module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.$props.loading),
      expression: "$props.loading"
    }],
    staticClass: "right-panel can-scroll"
  }, [_c('div', {
    staticClass: "entity-card"
  }, [_c('div', {
    staticClass: "entity-card-head"
  }, [_c('div', {
    staticClass: "entity-head-left"
  }, [_vm._t("header-left")], 2), _vm._v(" "), _c('div', {
    staticClass: "entity-head-center"
  }, [_vm._t("header-center")], 2), _vm._v(" "), _c('div', {
    staticClass: "entity-head-right"
  }, [_vm._t("header-right")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "entity-card-body"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a45a9d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EntityPage.vue
// module id = 1154
// module chunks = 0